import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-menubar',
  templateUrl: './menubar.component.html',
  styleUrls: ['./menubar.component.css']
})
export class MenuBarComponent implements OnInit {

  public isCollapsed: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

}
